module.exports = __webpack_public_path__ + "img/success.8c325fe0.png";